import { Directive, HostListener, Output, EventEmitter, ElementRef } from '@angular/core';

@Directive({
	selector: '[appScrollListener]',
	exportAs: 'appScrollListener',
})
export class ScrollListenerDirective {
	@Output() scrolled = new EventEmitter<Event>();

	constructor(public el: ElementRef<HTMLElement>) {}

	@HostListener('scroll', ['$event'])
	onScroll(event: Event) {
		this.scrolled.emit(event);
	}

	scrollToTop() {
		this.el.nativeElement.scrollTop = 0;
	}
}
